/** Resolves a safe skip/return path after leaving the welcome onboarding page. */
import { isOnboardingWelcomePath } from '@/constants/onboardingRoutes';

/** Default when skip has no valid return location (new users, direct welcome). */
export const ONBOARDING_WELCOME_SKIP_DEFAULT_PATH = '/app/today';

/**
 * @param {unknown} from — `location.state.from` from Help restart or manual navigation
 * @returns {string}
 */
export function resolveOnboardingWelcomeSkipPath(from) {
  if (typeof from !== 'string' || from.length === 0) {
    return ONBOARDING_WELCOME_SKIP_DEFAULT_PATH;
  }
  // Skip-to-welcome would loop; treat as invalid return.
  if (isOnboardingWelcomePath(from)) {
    return ONBOARDING_WELCOME_SKIP_DEFAULT_PATH;
  }
  if (from === '/app' || from.startsWith('/app/')) {
    return from;
  }
  return ONBOARDING_WELCOME_SKIP_DEFAULT_PATH;
}
